import { Route } from '@store/page';

export const ROUTES: Route[] = [
    {
        title: 'Dashboard',
        to: '/dashboard',
    },
    {
        title: 'Projects',
        to: '/projects',
    },
    {
        title: 'Users',
        to: '/users',
        roles: ['Administrator'],
    },
    {
        title: 'Customer Types',
        to: '/customer-types',
        roles: ['Administrator'],
    },
    {
        title: 'Resolutions',
        to: '/resolutions',
        roles: ['Administrator'],
    },
    {
        title: 'Audio Synchronizations',
        to: '/audio-synchronizations',
        roles: ['Administrator'],
        visible: false,
    },
    {
        title: 'Animation Modes',
        to: '/animation-modes',
        roles: ['Administrator'],
        visible: false,
    },
    {
        title: 'Generative Videos',
        to: '/generative-videos',
        roles: ['Administrator'],
        visible: false,
    },
    {
        title: 'Genres',
        to: '/genres',
        roles: ['Administrator'],
    },
    {
        title: 'Products',
        to: '/products',
        roles: ['Administrator'],
    },
    {
        title: 'Plans',
        to: '/plans',
        hasBullet: false,
    },
    {
        title: 'Account',
        to: '/my-account',
    },
];
